module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/sainik.component.css
// module id = ./src/app/sainik.component.css
// module chunks = main